import a from "./td-longtail-vue-components228.js";
/* empty css                              */
import l from "./td-longtail-vue-components98.js";
var o = function() {
  var e = this, r = e._self._c, t = e._self._setupProxy;
  return r(t.LinkButton, { staticClass: "dropdown-item", attrs: { role: "option", tag: t.hasLink ? "a" : "span", href: t.hasLink ? e.url : void 0, transparent: "", "is-external": !1, "aria-selected": e.selected ? "true" : "false", "aria-label": e.ariaLabel || e.label, "small-padding": "", tabindex: "0", disabled: e.disabled }, nativeOn: { keydown: [function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "enter", 13, n.key, "Enter") ? null : t.onClick.apply(null, arguments);
  }, function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : t.onClick.apply(null, arguments);
  }], click: function(n) {
    return t.onClick.apply(null, arguments);
  } } }, [r(t.DropdownItemContent, { attrs: { count: e.count, label: e.label, selected: e.selected, "break-text": e.breakText }, scopedSlots: e._u([{ key: "before", fn: function() {
    return [e._t("beforeLabel", null, { value: e.value })];
  }, proxy: !0 }], null, !0) })], 1);
}, s = [], i = /* @__PURE__ */ l(
  a,
  o,
  s,
  !1,
  null,
  "40a1cb37"
);
const f = i.exports;
export {
  f as default
};
